import React, { useState, useEffect, useRef } from 'react';
import { API, authFetch } from '../utils/api';

var MAX_SCREENSHOTS = 5;

function BugReportButton({ user, showToast }) {
  var [open, setOpen] = useState(false);
  var [listOpen, setListOpen] = useState(false);
  var [category, setCategory] = useState('bug');
  var [title, setTitle] = useState('');
  var [desc, setDesc] = useState('');
  var [screenshotFiles, setScreenshotFiles] = useState([]);
  var [screenshotPreviews, setScreenshotPreviews] = useState([]);
  var [sending, setSending] = useState(false);
  var [reports, setReports] = useState([]);
  var [detailReport, setDetailReport] = useState(null);
  var [detailSsUrl, setDetailSsUrl] = useState('');
  var [detailGallery, setDetailGallery] = useState([]);
  var [lightbox, setLightbox] = useState('');
  var pasteRef = useRef(null);

  var currentPage = window.location.hash || window.location.pathname;

  var loadReports = function() {
    authFetch(API + '/bug-reports').then(function(r) { return r.json(); }).then(function(d) {
      if (d.success) setReports(d.reports || []);
    }).catch(function() {});
  };

  useEffect(function() { loadReports(); }, []);

  var addFiles = function(filesToAdd) {
    if (!filesToAdd || filesToAdd.length === 0) return;
    setScreenshotFiles(function(prev) {
      var remaining = MAX_SCREENSHOTS - prev.length;
      if (remaining <= 0) {
        showToast('최대 ' + MAX_SCREENSHOTS + '장까지 첨부 가능합니다', 'err');
        return prev;
      }
      var allowed = [];
      for (var i = 0; i < filesToAdd.length && allowed.length < remaining; i++) {
        allowed.push(filesToAdd[i]);
      }
      if (filesToAdd.length > remaining) {
        showToast('최대 ' + MAX_SCREENSHOTS + '장 — ' + (filesToAdd.length - remaining) + '장 무시됨', 'err');
      }
      var newPreviews = allowed.map(function(f) { return URL.createObjectURL(f); });
      setScreenshotPreviews(function(prevP) { return prevP.concat(newPreviews); });
      return prev.concat(allowed);
    });
  };

  var handlePaste = function(e) {
    var items = e.clipboardData && e.clipboardData.items;
    if (!items) return;
    var pasted = [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].type.indexOf('image') >= 0) {
        var file = items[i].getAsFile();
        if (file) pasted.push(file);
      }
    }
    if (pasted.length > 0) addFiles(pasted);
  };

  var handleFileSelect = function(e) {
    if (e.target.files && e.target.files.length > 0) {
      addFiles(e.target.files);
      e.target.value = '';
    }
  };

  var removeScreenshot = function(idx) {
    setScreenshotFiles(function(prev) {
      var next = prev.slice(); next.splice(idx, 1); return next;
    });
    setScreenshotPreviews(function(prev) {
      var next = prev.slice();
      try { URL.revokeObjectURL(next[idx]); } catch (e) {}
      next.splice(idx, 1);
      return next;
    });
  };

  var submit = function() {
    if (!title.trim()) { showToast('제목을 입력해주세요', 'err'); return; }
    setSending(true);
    authFetch(API + '/bug-reports', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ category: category, title: title, description: desc, page: currentPage })
    }).then(function(r) { return r.json(); }).then(function(d) {
      if (d.success) {
        var reportId = d.id;
        if (screenshotFiles.length > 0 && reportId) {
          var fd = new FormData();
          screenshotFiles.forEach(function(f) { fd.append('screenshots', f); });
          authFetch(API + '/bug-reports/' + reportId + '/screenshots', { method: 'POST', body: fd })
            .then(function(res) { return res.json(); })
            .then(function(uploadRes) {
              setSending(false); resetForm();
              if (uploadRes && uploadRes.success) showToast('신고 접수 완료 (' + screenshotFiles.length + '장)');
              else showToast('신고 접수 (스크린샷 일부 업로드 실패)');
              loadReports();
            })
            .catch(function() { setSending(false); resetForm(); showToast('신고 접수 (스크린샷 업로드 실패)'); loadReports(); });
        } else {
          setSending(false); resetForm(); showToast('신고 접수 완료'); loadReports();
        }
      } else { setSending(false); showToast(d.error || '신고 실패', 'err'); }
    }).catch(function() { setSending(false); showToast('서버 오류', 'err'); });
  };

  var resetForm = function() {
    setOpen(false); setCategory('bug'); setTitle(''); setDesc('');
    screenshotPreviews.forEach(function(u) { try { URL.revokeObjectURL(u); } catch(e) {} });
    setScreenshotFiles([]); setScreenshotPreviews([]);
  };

  var openDetail = function(r) {
    setDetailReport(r);
    setDetailSsUrl('');
    setDetailGallery([]);
    if (r.screenshot) {
      authFetch(API + '/bug-reports/' + r.id + '/screenshot').then(function(res) { return res.blob(); }).then(function(blob) { setDetailSsUrl(URL.createObjectURL(blob)); }).catch(function() {});
    }
    if (r.screenshots && r.screenshots.length > 0) {
      var loaded = [];
      r.screenshots.forEach(function(s) {
        authFetch(API + '/bug-reports/' + r.id + '/screenshots/' + s.id).then(function(res) { return res.blob(); }).then(function(blob) {
          loaded.push({ id: s.id, url: URL.createObjectURL(blob), order_index: s.order_index });
          loaded.sort(function(a, b) { return a.order_index - b.order_index; });
          setDetailGallery(loaded.slice());
        }).catch(function() {});
      });
    }
  };

  var catKr = { bug: '버그', improvement: '개선요청', question: '질문' };
  var statusKr = { open: '접수', in_progress: '처리중', resolved: '해결', closed: '종료' };
  var statusColor = { open: '#3b82f6', in_progress: '#f59e0b', resolved: '#16a34a', closed: '#94a3b8' };

  return (
    <>
      {/* Floating button */}
      <div style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 9990, display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-end' }}>
        <button onClick={function() { setListOpen(!listOpen); if (!listOpen) loadReports(); }} style={{ width: 44, height: 44, borderRadius: '50%', border: 'none', background: '#475569', color: '#fff', fontSize: 18, cursor: 'pointer', boxShadow: '0 4px 12px rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} title="내 신고 목록">📋</button>
        <button onClick={function() { setOpen(true); }} style={{ width: 52, height: 52, borderRadius: '50%', border: 'none', background: '#dc2626', color: '#fff', fontSize: 22, cursor: 'pointer', boxShadow: '0 4px 16px rgba(220,38,38,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} title="오류 신고">🐛</button>
      </div>

      {/* Report modal */}
      {open && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }} onClick={resetForm}>
        <div style={{ background: '#fff', borderRadius: 16, padding: 24, width: 480, maxWidth: '94vw', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }} onClick={function(e) { e.stopPropagation(); }} onPaste={handlePaste} ref={pasteRef}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>오류/개선 신고</h3>
            <button onClick={resetForm} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#999' }}>✕</button>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 6 }}>분류</label>
            <div style={{ display: 'flex', gap: 8 }}>
              {[['bug', '🐛 버그'], ['improvement', '💡 개선요청'], ['question', '❓ 질문']].map(function(c) {
                var isActive = category === c[0];
                return <button key={c[0]} onClick={function() { setCategory(c[0]); }} style={{ flex: 1, padding: '8px 0', borderRadius: 8, border: '2px solid ' + (isActive ? '#2563eb' : '#e5e7eb'), background: isActive ? '#eff6ff' : '#fff', color: isActive ? '#2563eb' : '#64748b', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>{c[1]}</button>;
              })}
            </div>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 4 }}>제목 <span style={{ color: '#dc2626' }}>*</span></label>
            <input value={title} onChange={function(e) { setTitle(e.target.value); }} placeholder="간단한 제목" style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 8, border: '1px solid #d0d5dd', fontSize: 14, outline: 'none' }} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 4 }}>상세 설명</label>
            <textarea value={desc} onChange={function(e) { setDesc(e.target.value); }} placeholder="어떤 상황에서 어떤 문제가 발생했는지 설명해주세요" rows={4} style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 8, border: '1px solid #d0d5dd', fontSize: 13, outline: 'none', resize: 'vertical' }} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 4 }}>스크린샷 <span style={{ color: '#94a3b8', fontWeight: 400 }}>(Ctrl+V 또는 파일 선택, 최대 {MAX_SCREENSHOTS}장)</span></label>
            {screenshotPreviews.length > 0 && <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
              {screenshotPreviews.map(function(p, idx) {
                return <div key={idx} style={{ position: 'relative' }}>
                  <img src={p} alt={'shot-' + idx} style={{ width: 86, height: 86, objectFit: 'cover', borderRadius: 8, border: '1px solid #e5e7eb' }} />
                  <button onClick={function() { removeScreenshot(idx); }} style={{ position: 'absolute', top: 2, right: 2, background: '#dc2626', color: '#fff', border: 'none', borderRadius: '50%', width: 20, height: 20, fontSize: 11, cursor: 'pointer' }}>✕</button>
                </div>;
              })}
            </div>}
            {screenshotFiles.length < MAX_SCREENSHOTS && <input type="file" accept="image/jpeg,image/png,image/webp" multiple onChange={handleFileSelect} style={{ fontSize: 12 }} />}
            {screenshotFiles.length > 0 && <div style={{ fontSize: 11, color: '#64748b', marginTop: 4 }}>{screenshotFiles.length} / {MAX_SCREENSHOTS} 장</div>}
          </div>
          <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 16 }}>현재 페이지: {currentPage}</div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={resetForm} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13, color: '#555' }}>취소</button>
            <button onClick={submit} disabled={sending} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: 'none', background: sending ? '#aaa' : '#dc2626', color: '#fff', cursor: sending ? 'default' : 'pointer', fontSize: 13, fontWeight: 700 }}>{sending ? '전송 중...' : '신고하기'}</button>
          </div>
        </div>
      </div>}

      {/* My reports list */}
      {listOpen && <div style={{ position: 'fixed', bottom: 80, right: 20, zIndex: 9991, width: 380, maxHeight: 500, background: '#fff', borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.2)', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
        <div style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 700, fontSize: 14 }}>내 신고 목록 ({reports.length})</span>
          <button onClick={function() { setListOpen(false); }} style={{ background: 'none', border: 'none', fontSize: 16, cursor: 'pointer', color: '#999' }}>✕</button>
        </div>
        <div style={{ maxHeight: 400, overflowY: 'auto' }}>
          {reports.length === 0 && <div style={{ padding: '30px 16px', textAlign: 'center', color: '#aaa', fontSize: 13 }}>신고 내역이 없습니다</div>}
          {reports.map(function(r) {
            var shotCount = (r.screenshots && r.screenshots.length) || (r.screenshot ? 1 : 0);
            return <div key={r.id} style={{ padding: '10px 16px', borderBottom: '1px solid #f0f0f0', cursor: 'pointer' }} onClick={function() { openDetail(r); }} onMouseEnter={function(e) { e.currentTarget.style.background = '#f8fafc'; }} onMouseLeave={function(e) { e.currentTarget.style.background = '#fff'; }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ fontSize: 12 }}>{r.category === 'bug' ? '🐛' : r.category === 'improvement' ? '💡' : '❓'}</span>
                  <span style={{ fontSize: 13, fontWeight: 600, color: '#222' }}>{r.title}</span>
                  {shotCount > 0 && <span style={{ fontSize: 10, color: '#3b82f6' }}>📷 {shotCount}</span>}
                </div>
                <span style={{ fontSize: 10, fontWeight: 600, padding: '2px 6px', borderRadius: 4, background: statusColor[r.status] || '#94a3b8', color: '#fff' }}>{statusKr[r.status] || r.status}</span>
              </div>
              <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{(r.created_at || '').slice(0, 16)} · {catKr[r.category] || r.category}</div>
              {r.admin_reply && <div style={{ fontSize: 11, color: '#16a34a', marginTop: 3, fontWeight: 600 }}>💬 답변 있음</div>}
            </div>;
          })}
        </div>
      </div>}

      {/* Detail modal */}
      {detailReport && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }} onClick={function() { setDetailReport(null); }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: 24, width: 480, maxWidth: '94vw', maxHeight: '80vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }} onClick={function(e) { e.stopPropagation(); }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 style={{ margin: 0, fontSize: 16 }}>{catKr[detailReport.category] || ''} — {detailReport.title}</h3>
            <button onClick={function() { setDetailReport(null); }} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#999' }}>✕</button>
          </div>
          <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }}>신고일: {(detailReport.created_at || '').slice(0, 16)} · 상태: <span style={{ fontWeight: 700, color: statusColor[detailReport.status] || '#94a3b8' }}>{statusKr[detailReport.status] || detailReport.status}</span></div>
          {detailReport.page && <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 8 }}>페이지: {detailReport.page}</div>}
          {detailReport.description && <div style={{ padding: '10px 12px', background: '#f8fafc', borderRadius: 8, fontSize: 13, color: '#333', marginBottom: 12, whiteSpace: 'pre-wrap' }}>{detailReport.description}</div>}
          {detailReport.screenshot && <div style={{ marginBottom: 12 }}>{detailSsUrl ? <img src={detailSsUrl} alt="screenshot" style={{ maxWidth: '100%', maxHeight: 250, borderRadius: 8, border: '1px solid #e5e7eb', cursor: 'zoom-in' }} onClick={function() { setLightbox(detailSsUrl); }} /> : <div style={{ padding: 12, textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>스크린샷 로딩 중...</div>}</div>}
          {detailGallery.length > 0 && <div style={{ marginBottom: 12, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {detailGallery.map(function(g) {
              return <img key={g.id} src={g.url} alt={'shot-' + g.id} onClick={function() { setLightbox(g.url); }} style={{ width: 110, height: 110, objectFit: 'cover', borderRadius: 8, border: '1px solid #e5e7eb', cursor: 'zoom-in' }} />;
            })}
          </div>}
          {detailReport.admin_reply ? <div style={{ padding: '10px 12px', background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 8 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#16a34a', marginBottom: 4 }}>관리자 답변</div>
            <div style={{ fontSize: 13, color: '#333', whiteSpace: 'pre-wrap' }}>{detailReport.admin_reply}</div>
            {detailReport.resolved_at && <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 4 }}>처리일: {(detailReport.resolved_at || '').slice(0, 16)}</div>}
          </div> : <div style={{ fontSize: 12, color: '#94a3b8', fontStyle: 'italic' }}>아직 답변이 없습니다</div>}
        </div>
      </div>}

      {/* Lightbox */}
      {lightbox && <div onClick={function() { setLightbox(''); }} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 999999, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'zoom-out' }}>
        <img src={lightbox} alt="zoom" style={{ maxWidth: '94vw', maxHeight: '94vh', borderRadius: 8 }} />
      </div>}
    </>
  );
}

export default BugReportButton;
